import { theme } from 'theme'
import styled, { css, CSSProp } from 'particles/themes/styled'
import { CAMPAIGN_STATUS_ENUM, CAMPAIGN_SUBMISSION_STATUS_ENUM } from 'state/campaigns'

export const summaryInnerCardButtonsStyle = css`
    display: none;
    margin-top: 20px;
    margin-bottom: 20px;
    padding-top: 20px;
    border-top: 1px solid ${theme.newColors.neutral200};
    @media screen and (min-width: 0px) {
        display: flex;
    }
    @media screen and (min-width: 768px) {
        display: none;
    }
`

export const buttonListWidth = css`
    width: 100%;
`

interface CardProp {
    campaignStatus: CAMPAIGN_STATUS_ENUM
    campaignSubmissionStatus: CAMPAIGN_SUBMISSION_STATUS_ENUM
}

export const SummaryCardContainer = styled.div<CardProp>`
    min-height: 250px;
    .card-content {
        display: flex;
        background: ${theme.newColors.neutral50};
        height: calc(100% - 40px);
    }
    .task-block-layout {
        -webkit-box-flex: 1;
        flex-grow: 1;
        padding: ${theme.newSpacing.m};
        overflow: hidden;
    }
    .task-block-content {
        display: flex;
        margin-bottom: ${theme.newSpacing.m};
        -webkit-box-align: center;
        align-items: center;
    }
    .brand-image {
        max-width: 100%;
        width: 30px;
        height: 30px;
    }
    .brand-block {
        flex: 1 1 0%;
        margin-left: ${theme.newSpacing.xxs};
        width: calc(100% - 38px);
    }
    .day-left-block {
        margin-bottom: ${theme.newSpacing.xxs};
    }
    .task-list {
        display: flex;
        gap: 20px;
        flex-wrap: wrap;
        -webkit-box-pack: start;
        justify-content: flex-start;
        align-items: flex-start;
        @media screen and (max-width: 425px) {
            justify-content: space-evenly;
        }
    }
    .submission-status-container {
        background-color: ${theme.newColors.neutral50};
        width: 100%;
        border-top: 1px solid ${theme.newColors.neutral200};
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .submission-status-text {
        text-align: center;
        padding-top: ${theme.newSpacing.xs};
        padding-bottom: ${theme.newSpacing.xs};
        align-items: center;
        margin-right: ${theme.newSpacing.xxxxs};
    }
    .button-block-container {
        border-left: 1px solid ${theme.newColors.neutral200};
        flex: 1;
        padding: ${theme.newSpacing.m};
        max-width: 142px;
        min-width: 142px;
        justify-content: center;
        @media screen and (min-width: 0px) {
            display: none;
        }
        @media screen and (min-width: 768px) {
            display: flex;
        }
    }
    .empty-box {
        width: 100px;
    }
`

export const TaskBlockContainer = styled.div`
    margin-top: ${theme.newSpacing.m};
    margin-bottom: ${theme.newSpacing.m};
    border-radius: ${theme.newSpacing.xxxxs};
    position: relative;
    width: 100px;
    .bubble-container {
        display: flex;
        border-radius: ${theme.newSpacing.l};
        position: absolute;
        right: -${theme.spacing.xxxs};
        top: -${theme.spacing.xxxs};
        width: ${theme.newSpacing.l};
        height: ${theme.newSpacing.l};
        background-color: ${theme.newColors.alertError200};
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
    }
    .bubble-complete {
        background-color: ${({ theme }) => theme.colors.surface.neutralActionHover};
    }
    .bubble-text {
        font-size: ${theme.newFontSizes.xs};
        font-weight: ${theme.fontWeight.bold};
        color: ${theme.newColors.neutral50};
        text-align: center;
    }
    .task-image-contaner {
        display: flex;
        background-color: ${theme.newColors.neutral100};
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        border-radius: ${theme.newSpacing.xxxxs};
        width: 100px;
        height: 100px;
    }

    .task-image {
        max-width: 100%;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center center;
        border: none;
        border-radius: ${theme.newSpacing.xxxxs};
    }
`

interface ButtonListProps {
    customStyle?: CSSProp
}
export const ButtonListContainer = styled.div<ButtonListProps>`
    display: flex;
    flex-direction: column;
    .campaign-type-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        justify-content: center;
        margin-bottom: ${theme.newFontSizes.m};
    }
    .campaign-type-icon {
        display: flex;
        margin-right: ${theme.newSpacing.xxxxs};
        justify-content: center;
        align-items: center;
    }
    .campaign-overall-time-window {
        margin-bottom: ${theme.newFontSizes.m};
        @media screen and (min-width: 0px) {
            display: flex;
            justify-content: space-between;
        }
        @media screen and (min-width: 768px) {
            display: block;
        }
    }
    .nav-button-container {
        min-width: 142px;
        display: grid;
        grid-gap: ${theme.newSpacing.xxs};
    }
    &.customStyle {
        ${({ customStyle }): CSSProp | undefined => customStyle};
    }
`

export const ProgressContainer = styled.div`
    .progress-container {
        width: 100%;
        padding-top: ${theme.newSpacing.xxs};
        padding-bottom: ${theme.newSpacing.xxs};
        &:hover .linear-progress {
            outline: 1px solid ${theme.newColors.primary300};
        }
    }
    .linear-progress {
        background-color: ${theme.newColors.neutral100};
    }
`

export const DeadlineTextContainer = styled.div`
    margin-top: ${theme.newSpacing.m};
`
